/**
 * Handle behaviour of the member list in the GSA page
 */
jQuery(function($){

	$('.gsa-member').on('click', function() {
		$(this).toggleClass('active');
	});
});